export const BUSINESS_NAME = 'Kjergaard Sports'
export const PHONE = '507-368-4696'
export const PHONE_TEL = 'tel:507-368-4696'
export const ADDRESS_LINE_1 = '1951 200th Avenue'
export const ADDRESS_LINE_2 = 'Lake Benton, Minnesota 56149'
// Use a business-name-based Google Maps search until the exact Google Business Profile / Place link is provided.
// Final WebsiteForge setup should replace this URL with the exact Kjergaard Sports Google Business Profile / Place link once available.
export const GOOGLE_MAPS_URL =
  'https://www.google.com/maps/search/?api=1&query=Kjergaard%20Sports%20Lake%20Benton%20Minnesota'
export const FACEBOOK_URL =
  'https://www.facebook.com/profile.php?id=100057537217940'
export const WEBSITE_URL = 'https://www.ksportsllc.com/'
